import { useRouter } from 'next/router'

const BlogMobileSubCategorySection = ({ subMenu, selected, setSelected }) => {
  const router = useRouter()
  const sortedMenu = subMenu.sort((a, b) => a.id - b.id)

  const handleSubCategoryClick = (subItem) => {
    const { query } = router
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...query,
          subcategory: subItem._id,
        },
      },
      undefined,
      { shallow: true }
    )
    setSelected(subItem)
  }

  return (
    <div className={style.subCategoryWrapper}>
      {sortedMenu.map((subItem, i) => {
        return (
          <button
            className={style.subCategorySectionItem(subItem._id === selected._id)}
            key={i}
            onClick={() => handleSubCategoryClick(subItem)}
          >
            {subItem.title}
          </button>
        )
      })}
    </div>
  )
}

export default BlogMobileSubCategorySection

const style = {
  subCategoryWrapper: `no-scrollbar my-[20px] flex flex-wrap gap-[8px] overflow-x-scroll pr-[16px] pl-[20px]`,
  subCategorySectionItem: (isSelected) =>
    isSelected
      ? `Body2-14Bd whitespace-nowrap rounded-[8px] border-[1.5px] border-purple-500 bg-purple-50 px-[12px] py-[8px] text-purple-500`
      : `Body2-14Md whitespace-nowrap rounded-[8px] border-[1.5px] border-gray-300 px-[12px] py-[8px]`,
}
